export enum DocuSignModes {
  VIEW = 'view',
  SIGN = 'sign'
}
